import hotkeys, { type KeyHandler } from "hotkeys-js";
import type React from "react";
import { useEffect } from "react";

export const useHotkeys = (keys: string, callback: KeyHandler) => {
    useEffect(() => {
        hotkeys(keys, callback);
        return () => {
            hotkeys.unbind(keys, callback);
        };
    }, [keys, callback]);
};

export const useClickOutside = (ref: React.RefObject<HTMLElement>, handler: () => void) => {
    useEffect(() => {
        const listener = (e: MouseEvent) => {
            if (!ref.current || ref.current.contains(e.target as Node)) {
                return;
            }
            handler();
        };

        document.addEventListener("mousedown", listener);
        return () => document.removeEventListener("mousedown", listener);
    }, [handler, ref.current]);
};
